import { NewTabLink } from "../UI/NewTabLink";

export function IsSummer(props: { Campus: string, AcadYearLabel: string }) {
    const CampusLink = props.Campus.replaceAll("Campus", "").replaceAll(" ", "").toLowerCase();

    const linkURL = "https://www.essex.ac.uk/life/accommodation/apply/short-stay-and-vacation";

    return <div className="OtherData_Container">
        <fieldset className="OtherData">
            <legend>{props.AcadYearLabel} accommodation applications</legend>

            <h2>Summer vacation accommodation for students ({CampusLink} Campus)</h2>

            <p>Please read all of the information on our Short stay and vacation applications page before booking accommodation:</p>

            <p><NewTabLink to={linkURL}>{linkURL}</NewTabLink>.</p>
        </fieldset>
    </div>;
}